// @ts-ignore-start
export const shadeColor = (color: string, amount: number) => '#' + color.replace(/^#/, '').replace(/../g, color => ('0'+Math.min(255, Math.max(0, parseInt(color, 16) + amount)).toString(16)).substr(-2));
// @ts-ignore-end

export const generatePastelColor = () => "hsl(" + 360 * Math.random() + ',' +
               (25 + 70 * Math.random()) + '%,' + 
               (85 + 10 * Math.random()) + '%)';

export const generateColor = () => `#${Math.floor(Math.random()*16777215).toString(16)}`;

export const exportAsCsv = (header : Array<string>, attributeNames : Array<string>, data : Array<object>, downloadName : string) => {
    let headerCopy:any = [[...header]];
    let csvRow = [];
    for(let i = 0; i < data.length; i++){
        let element:any = data[i];
        let strings:Array<string> = [];
        attributeNames.forEach((name:string) => {
            strings.push(element[name] ? `"${element[name]}"` : "N.A.");
        })
        headerCopy.push(strings);
    }
    for(let i = 0; i < headerCopy.length; i++){
        //console.log("Pushing to csvRow", i)
        csvRow.push(headerCopy[i].join(","))
    }
    let csvString = csvRow.join("\r\n");//adds space
    //console.log("final csv string", csvString);
    let a = document.createElement("a");//created <a> tag
    // set attributes of a tag
    let hrefValue = "data:attachment/csv;charset=utf-8, " + csvString;
    //console.log("Href value", hrefValue);
    a.href = hrefValue;
    a.target = "_Blank";
    a.download = downloadName + ".csv";
    document.body.appendChild(a);
    // trigger download
    //console.log("Triggering click now");
    a.click();
}

/**
 * @license
 *
 * The MIT License (MIT)
 *
 * Copyright (c) 2014 Nick Williams
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */

/**
 * generates factory functions to convert table rows to objects,
 * based on the titles in the table's <thead>
 * @param  {Array<String>} headings the values of the table's <thead>
 * @return {(row: HTMLTableRowElement) => Object} a function that takes a table row and spits out an object
 */
function mapRow(headings: any) {
    return function mapRowToObject(value: any) {
        let cells: any = value.cells;
        return [...cells].reduce(function(result, cell, i) {
            const input = cell.querySelector("input,select");
            var value;

            if (input) {
            value = input.type === "checkbox" ? input.checked : input.value;
            } else {
            value = cell.innerText;
            }

            return Object.assign(result, { [headings[i]]: value });
        }, {});
    };
}

/**
   * given a table, generate an array of objects.
   * each object corresponds to a row in the table.
   * each object's key/value pairs correspond to a column's heading and the row's value for that column
   *
   * @param  {HTMLTableElement} table the table to convert
   * @return {Array<Object>}       array of objects representing each row in the table
   */
export function parseTable(table: any) {
    var headings = [...table.tHead.rows[0].cells].map(
        heading => heading.innerText.replace(/\s/g, '')
    );

    return [...table.tBodies[0].rows].map(mapRow(headings));
}